import { collections } from "../../data/collections";
import CollectionCard2 from "../../components/CollectionCard2/CollectionCard2";

const AllCollections = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20">
            <div className="py-10 md:py-20 lg:pb-36">

                <div className="flex flex-wrap justify-between items-center mb-10 md:mb-20">
                    <h2 className="text-center text-xl lg:text-2xl xl:text-3xl text-white">All Collections</h2>
                    <select className="bg-transparent ">
                        <option value="">Top Collections</option>
                    </select>
                </div>

                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 justify-items-center">
                    {collections.map((item, index) => {
                        return(
                            <CollectionCard2 item={item} key={index} className="max-w-[400px]"/>
                        )
                    })}
                </div>


            </div>


        </div>
    )
}

export default AllCollections;